import axios from "axios";

class Login {

	login_google()
	{
		return new Promise(function (resolve, reject) {
			//console.log(`${process.env.VUE_APP_SAAS_BACK}` + '/users/login')
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/users/login_google")
				.catch(function (error) {
					reject(error);
				});
		});
	}

	auth(login, password, client = null, user_client = null) {
		return new Promise(function (resolve, reject) {
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/users/login", {
					login: login,
					password: password,
					client: client,
					user_client: user_client
				})
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	authSSO(token) {
		return new Promise(function (resolve, reject) {
			//console.log(`${process.env.VUE_APP_SAAS_BACK}` + '/users/login')
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/users/login_sso", {
					token: token
				})
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}
}

export default new Login();
